import React from 'react';
import { shape, bool, string, number, oneOfType } from 'prop-types';

import Section from '~/views/common/Section';
import DataTable from '~/views/common/DataTable';
import BoolIcon from '~/views/common/BoolIcon';


const Address = ({
    address: {
        unknown,
        virtual,
        street,
        street2,
        postal,
        city,
        county,
        state,
        country,
        latitude,
        longitude,
    },
}) => (
    <Section name="Address">
        <DataTable.Body>
            <DataTable.Row header="Unknown">
                <BoolIcon value={unknown} />
            </DataTable.Row>

            <DataTable.Row header="Virtual">
                <BoolIcon value={virtual} />
            </DataTable.Row>

            <DataTable.Row header="Street">{ street }</DataTable.Row>
            <DataTable.Row header="Street2">{ street2 }</DataTable.Row>

            <DataTable.Row header="Postal">{ postal }</DataTable.Row>

            <DataTable.Row header="City">{ city }</DataTable.Row>
            <DataTable.Row header="County">{ county }</DataTable.Row>

            <DataTable.Row header="State">{ state }</DataTable.Row>
            <DataTable.Row header="Country">{ country }</DataTable.Row>

            <DataTable.Row header="Latitude">{ latitude }</DataTable.Row>
            <DataTable.Row header="Longitude">{ longitude }</DataTable.Row>
        </DataTable.Body>
    </Section>
);


Address.defaultProps = {
    address: {
        unknown: false,
        virtual: false,
        street: '',
        street2: '',
        postal: '',
        city: '',
        county: '',
        state: '',
        country: '',
        latitude: 0,
        longitude: 0,
    },
};

Address.propTypes = {
    address: shape({
        unknown: bool,
        virtual: bool,
        street: string,
        street2: string,
        postal: oneOfType([number, string]),
        city: string,
        county: string,
        state: string,
        country: string,
        latitude: number,
        longitude: number,
    }),
};

export default Address;
